import type { SVGProps } from 'react';

export const ReportsNdviIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M4.5 1.5H10.5L15 6V12H13.5V6.75H9.75V3H4.5V15H10.5V16.5H4.4925C3.6675 16.5 3 15.825 3 15V3C3 2.175 3.675 1.5 4.5 1.5Z"
      fill={props.fill ?? '#696F88'}
    />
    <path d="M12 12V13.5H6V12H12Z" fill={props.fill ?? '#696F88'} />
    <path d="M6 9H12V10.5H6V9Z" fill={props.fill ?? '#696F88'} />
    <path
      d="M15 13.5H13.5V15H12V16.5H13.5V18H15V16.5H16.5V15H15V13.5Z"
      fill={props.fill ?? '#696F88'}
    />
  </svg>
);
